import { HomePage, LastWorkspaceResolver, LazyPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function HomeIndexRoute() {
  return (
    <LastWorkspaceResolver>
      <LazyPage>
        <HomePage />
      </LazyPage>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/home/')({
  component: HomeIndexRoute,
});
